import { useMutation } from 'react-query';
import { goLiveSingleEndpoint, goLiveMultiEndpoint } from './endpoints';
import { Id } from 'new/api/types';
import { GoLiveMultiRequest } from './types.ts';

export const useGoLiveSingle = (dentistInfoId?: Id) =>
  useMutation(() => goLiveSingleEndpoint.endpoint(undefined, dentistInfoId));

export const useGoLiveMulti = (dentistInfoId: Id) =>
  useMutation<unknown, unknown, GoLiveMultiRequest>((params) =>
    goLiveMultiEndpoint.endpoint(params, dentistInfoId),
  );
